import HttpRequest from '../request'
import { BasicApi, TranslateApi, TranslatePageApi, AccountArtApi } from '../api'

const requestOptions = (signal?: AbortSignal) => ({ signal, timeout: 30000 })

export default {
  prompts: (signal?: AbortSignal) => HttpRequest.get('/api/core/prompt/client/get/image/prompt', null, requestOptions(signal)),
  billing: (signal?: AbortSignal) => HttpRequest.get(BasicApi.getEnterpriseConfig, null, requestOptions(signal)),
  preUpload: (data: Record<string, any>, signal?: AbortSignal) => HttpRequest.post(TranslatePageApi.getAwsUploadFileUrlApi, data, requestOptions(signal)),
  confirmUpload: (data: Record<string, any>, signal?: AbortSignal) => HttpRequest.post(TranslatePageApi.getAwsUploadFileApi, data, requestOptions(signal)),
  translate: (data: Record<string, any>, signal?: AbortSignal) => HttpRequest.post(TranslateApi.getTranslate, data, requestOptions(signal)),
  status: (key: string, signal?: AbortSignal) => HttpRequest.get(TranslateApi.getTranslateCheckStatus, { queryFileKey: key }, requestOptions(signal)),
  detail: (id: number, signal?: AbortSignal) => HttpRequest.get(TranslateApi.getOperateRecordId, { thisId: id }, requestOptions(signal)),
  compare: (id: number, signal?: AbortSignal) => HttpRequest.get(AccountArtApi.getAccountFileCompare, { operateRecordId: id }, requestOptions(signal)),
  overwrite: (id: number, signal?: AbortSignal) => HttpRequest.post('/api/core/pdf/trans/aws/pre/upload/photo', { operateRecordId: id }, requestOptions(signal)),
}

/** 预签名 PUT 不附带应用的 token / bizTeamId，也不经过文档上传的全局事件总线。 */
export function putEnterpriseImage(url: string, blob: Blob, contentType: string, signal: AbortSignal, onProgress?: (percent: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const abort = () => xhr.abort()
    const finish = (error?: Error) => {
      signal.removeEventListener('abort', abort)
      error ? reject(error) : resolve()
    }
    if (signal.aborted) { reject(new DOMException('Aborted', 'AbortError')); return }
    xhr.open('PUT', url)
    xhr.timeout = 120000
    xhr.setRequestHeader('Content-Type', contentType)
    xhr.upload.onprogress = event => { if (event.lengthComputable) onProgress?.(Math.min(99, event.loaded / event.total * 100)) }
    xhr.onload = () => finish(xhr.status >= 200 && xhr.status < 300 ? undefined : new Error('bizImage_err_upload'))
    xhr.onerror = xhr.ontimeout = () => finish(new Error('bizImage_err_upload'))
    xhr.onabort = () => finish(new DOMException('Aborted', 'AbortError'))
    signal.addEventListener('abort', abort, { once: true })
    xhr.send(blob)
  })
}
